import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = () => {
  const { currentUser, loading } = useAuth();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  
  // If user is not logged in or not an admin, redirect to home page
  // Otherwise, render the admin component
  return currentUser && currentUser.is_admin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute;
